import { GraduationCap, Award, BookOpen } from "lucide-react";
import { education, certifications, publications } from "../../data/resume";

export const Education = () => {
  return (
    <section
      id="education"
      data-testid="education-section"
      className="py-24 md:py-32 bg-white border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal max-w-2xl">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-slate-500 mb-4">
            Credentials
          </p>
          <h2 className="font-serif font-semibold text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Education, certifications & research.
          </h2>
        </div>

        <div className="mt-16 grid lg:grid-cols-12 gap-12">
          {/* Education */}
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-7">
              <GraduationCap className="h-5 w-5 text-brass" strokeWidth={1.5} />
              <h3 className="text-sm uppercase tracking-[0.16em] font-semibold text-ink">
                Education
              </h3>
            </div>
            <ol className="relative border-l border-border ml-1.5 space-y-8">
              {education.map((e, i) => (
                <li
                  key={i}
                  data-testid={`education-item-${i}`}
                  className="relative pl-8"
                >
                  <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 bg-ink" />
                  <h4 className="font-serif text-lg md:text-xl text-ink font-medium leading-snug">
                    {e.degree}
                  </h4>
                  <p className="text-sm text-slate-500 mt-1">{e.school}</p>
                </li>
              ))}
            </ol>
          </div>

          {/* Certs + publications */}
          <div className="lg:col-span-5 space-y-12">
            <div className="reveal" style={{ transitionDelay: "0.1s" }}>
              <div className="flex items-center gap-3 mb-7">
                <Award className="h-5 w-5 text-brass" strokeWidth={1.5} />
                <h3 className="text-sm uppercase tracking-[0.16em] font-semibold text-ink">
                  Certifications
                </h3>
              </div>
              <ul className="space-y-3">
                {certifications.map((c) => (
                  <li
                    key={c}
                    data-testid={`certification-${c}`}
                    className="border border-border bg-paper px-5 py-4 text-slatey"
                  >
                    {c}
                  </li>
                ))}
              </ul>
            </div>

            <div className="reveal" style={{ transitionDelay: "0.15s" }}>
              <div className="flex items-center gap-3 mb-7">
                <BookOpen className="h-5 w-5 text-brass" strokeWidth={1.5} />
                <h3 className="text-sm uppercase tracking-[0.16em] font-semibold text-ink">
                  Publications
                </h3>
              </div>
              {publications.map((p, i) => (
                <div
                  key={i}
                  data-testid={`publication-${i}`}
                  className="border-l-2 border-brass pl-5"
                >
                  <p className="text-slatey leading-relaxed italic">{p.citation}</p>
                  <p className="text-sm text-slate-500 mt-2">{p.publisher}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
